import { location } from '@townsquare/facade';
import Loadable from '@townsquare/loadable';
import { createSearchParamsFromCurrentUrl } from '@townsquare/search-params';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

export const TeamsApp = Loadable({
  loader: () => import(/* webpackChunkName: "goals-app-entry" */ '@townsquare/teams/app'),
  loading: () => null,
});

const ORG_SITE_ROUTE_REGEX = new RegExp(`^/o/(?<orgIdentifier>[0-9a-zA-Z-]+)(/s/(?<siteIdentifier>[a-zA-Z0-9%+-]+))*`);

export function shouldRedirectToTeamsApp() {
  // 1. Check if the pathname starts with '/people'
  const pathname = location().pathname.replace(ORG_SITE_ROUTE_REGEX, '');
  // 2. Check if the noWorkspace parameter is set to true
  // This is a temporary hack to redirect no workspace users to the home app until titan dependency is removed
  const searchParams = createSearchParamsFromCurrentUrl();
  const noWorkspace = searchParams.get('homeRedirect') === 'true';
  return pathname.startsWith('/people') && !noWorkspace && isGateEnabled('atlas_teams_app_enabled');
}
